import React, { useEffect, useState } from "react";
import Button from "../../components/Button";
import DesktopContainerAuth from "../../components/DesktopContainerAuth";
import Label from "../../components/Label";
import Loading from "../../components/Loading";
import TextInput from "../../components/TextInput";
import { useHistory } from "react-router-dom";
import { schemaActivationCode } from "./validation";
import handleErrors from "../../helpers/handleErrors";
import { validateCode } from "../../services/auth";
import ContactAuth from "components/Views/ContactAuth";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";

type Props = {};

const ActivationCode: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();

  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>();

  const [code, setCode] = useState("");
  const [state, setState] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    localStorage.clear();
    setRole(history.location.pathname.split("/")[2]);
    localStorage.setItem("role", role);

    if (history.location.state.state && history.location.state.email) {
      setState(history.location.state.state);
      setEmail(history.location.state.email);
    }
  }, [history, role]);

  const addClassButton = () => {
    if (errors?.code) {
      return "bg-bt-red text-white";
    }

    if (code) {
      return "bg-bt-green text-white";
    }

    return "bg-bt-light-gray text-black";
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (!schemaActivationCode.isValidSync({ code, email, state, role })) {
        handleErrors({
          schema: schemaActivationCode,
          stateData: { code, email, state, role },
          setErrorMessage: setErrors,
        });
        setLoading(false);
        return;
      }

      const { data } = await validateCode({
        email,
        code,
        state,
        role,
      });

      toastMessage({
        message: "Validation code successfully.",
        type: "success",
      });

      if (data) {
        history.push(`/new-password/${role}`, {
          state: data.state,
          email,
          role,
        });
      }
    } catch (error: any) {
      let message;

      if (error.response.data.error === "Confirmation code not found.") {
        message = "Confirmation code not found.";
        setErrors({ code: error.response.data.error });
      }

      toastMessage({
        message: message ? message : "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DesktopContainerAuth>
      <Loading loading={loading} />
      <div className="flex flex-col">
        <div className="w-96 mx-auto">
          <Label
            label={"Forgot Password?"}
            className="font-light text-xl text-bt-purple"
          />
          <Label
            label={
              "Please check your inbox and enter the temporary password we sent you"
            }
            style={{
              color: "#4D4F5C",
              opacity: 0.5,
            }}
            className="mt-4 text-center font-light text-base"
          />
          <TextInput
            placeholder={"Code"}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            isHelp={errors?.code}
            helpText={errors?.code}
          />
          <Button
            label={"Verify"}
            className={`mt-12 rounded-lg font-sora font-normal2 text-base h-8 w-full ${addClassButton()}`}
            onClick={handleSubmit}
          />
        </div>
        <ContactAuth
          title={"Request your access"}
          subTitle={
            "Are you an adoption professional and feel this would be the perfect solution for your business?"
          }
          titleButton={"Contact form"}
          action={"/signup/entity"}
        />
        <div className="mt-12">
          <Label
            label={"Term of use. Privacy policy"}
            className="flex flex-row justify-center font-nunito font-light text-xs"
          />
        </div>
      </div>
      <ToastContainer />
    </DesktopContainerAuth>
  );
};

export default ActivationCode;
